if (!customElements.get('brutal-video')) {
  customElements.define(
    'brutal-video',
    class BrutalVideo extends HTMLElement {
      connectedCallback() {
        const poster = this.querySelector('.brutal-videos__poster');
        if (!poster) return;
        poster.addEventListener('click', () => this.play(), { once: true });
      }

      play() {
        const id = this.dataset.videoId;
        if (!id) return;
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0&playsinline=1`;
        iframe.title = this.querySelector('.brutal-videos__poster')?.getAttribute('aria-label') || 'Video';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        this.replaceChildren(iframe);
      }
    }
  );
}
